import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Row,
  Col,
  Grid
} from 'react-bootstrap';
import cx from 'classnames';
import moment from 'moment';

import Link from '../Link';
import { withQuery } from '../../hoc/withGraphql';

import messages from '../../locale/messages';
import getEnabledBlog from './getEnabledBlog.graphql';
import getAllStaticPage from './getAllStaticPage.graphql';

import PlayStoreImage from '/public/SiteImages/playStore.png';
import AppStoreImage from '/public/SiteImages/appStore.png';
import facebookIcon from '/public/SiteImages/facebook.svg';
import twitterIcon from '/public/SiteImages/twitter.svg';
import instagramIcon from '/public/SiteImages/instagram.svg'

import s from './Footer.css';
import cs from '../commonStyle.css';
class Footer extends React.Component {

  static propTypes = {
    siteName: PropTypes.string.isRequired,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    appAvailableStatus: PropTypes.string,
    playStoreUrl: PropTypes.string,
    appStoreUrl: PropTypes.string,
    formatMessage: PropTypes.any,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getEnabledBlog: PropTypes.array,
    })
  };

  constructor(props) {
    super(props);

  }

  render() {
    const { siteName, facebook, twitter, instagram, appAvailableStatus, playStoreUrl, appStoreUrl } = this.props;
    const { data: { getEnabledBlog }, data: { getAllStaticPage } } = this.props;
    const aboutPage = getAllStaticPage?.results?.find(page => page.id === 1 && page.isEnable);
    const safetyPage = getAllStaticPage?.results?.find(page => page.id === 2 && page.isEnable);
    const privacyPage = getAllStaticPage?.results?.find(page => page.id === 4 && page.isEnable);
    const termsOfServicePage = getAllStaticPage?.results?.find(page => page.id === 7 && page.isEnable);

    return (
      <footer>
        <div
          className={cx(s.footerBgBanner, 'commonWordBreak', s.footerSectionPadding)} >
          <Grid fluid className={cx(s.footerSectionContainer, 'hidden-print')}>
            <Row>
              <Col sm={12} md={12} lg={12} xs={12}>
                <div className={s.displayGrid}>
                  <div>
                    <label className={cx(s.landingLabel, cs.space1)}>{siteName}</label>
                    <ul className={s.listContainer}>
                      {aboutPage && (<li className={cs.spaceTop2}>
                        <Link to={'/about'} className={s.textLink} >
                          <FormattedMessage {...messages.about} />
                        </Link>
                      </li>)
                      }
                      <li className={cs.spaceTop2}>
                        <Link to={'/contact'} className={s.textLink} >
                          <FormattedMessage {...messages.contactForm} />
                        </Link>
                      </li>
                      {
                        getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.filter((item) => item.footerCategory != 'discover' && item.footerCategory != 'hosting')
                          .map((item, index) => {
                            return (
                              <li key={index + 1} className={cs.spaceTop2}>
                                <Link to={'/page/' + item.pageUrl} className={s.textLink} >
                                  {item.pageTitle}
                                </Link>
                              </li>
                            )
                          })
                      }
                    </ul>
                  </div>
                  {(safetyPage || getEnabledBlog?.length > 0) && <div>
                    <label className={cx(s.landingLabel, cs.space1)}><FormattedMessage {...messages.discover} /></label>
                    <ul className={s.listContainer}>
                      {safetyPage && (<li className={cs.spaceTop2}>
                        <Link to={'/safety'} className={s.textLink} >
                          <FormattedMessage {...messages.trustSafety} />
                        </Link>
                      </li>)
                      }
                      {
                        getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.filter((item) => item.footerCategory == 'discover')
                          .map((item, index) => {

                            return (
                              <li key={index + 1} className={cs.spaceTop2}>
                                <Link to={'/page/' + item.pageUrl} className={s.textLink} >
                                  {item.pageTitle}
                                </Link>
                              </li>
                            )

                          })
                      }
                    </ul>
                  </div>}
                  <div>
                    <label className={cx(s.landingLabel, cs.space1)}><FormattedMessage {...messages.hosting} /></label>
                    <ul className={s.listContainer}>
                      <li className={cs.spaceTop2}>
                        <Link to={'/whyhost'} className={s.textLink} >
                          <FormattedMessage {...messages.becomeAHost} />
                        </Link>
                      </li>
                      {privacyPage && (<li className={cs.spaceTop2}>
                        <Link to={'/privacy'} className={s.textLink} >
                          <FormattedMessage {...messages.termsPrivacy} />
                        </Link>
                      </li>)
                      }
                      {termsOfServicePage && (<li className={cs.spaceTop2}>
                        <Link to={'/terms-of-service'} className={s.textLink} >
                          <FormattedMessage {...messages.termsOfService} />
                        </Link>
                      </li>)
                      }
                      {
                        getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.filter((item) => item.footerCategory == 'hosting')
                          .map((item, index) => {
                            return (
                              <li key={index + 1} className={cs.spaceTop2}>
                                <Link to={'/page/' + item.pageUrl} className={s.textLink} >
                                  {item.pageTitle}
                                </Link>
                              </li>
                            )
                          })
                      }
                    </ul>
                  </div>
                  <div>
                    {
                      appAvailableStatus == 1 && (playStoreUrl || appStoreUrl) &&
                      <div>
                        <label className={cx(s.landingLabel, cs.space3)}><FormattedMessage {...messages.appsAvailableOn} /></label>
                        <div className={s.appsSectionFlex}>
                          {
                            playStoreUrl && <a href={playStoreUrl} target="_blank" className={s.displayInlineBlock}>
                              <img alt="Image" src={PlayStoreImage} />
                            </a>
                          }
                          {
                            appStoreUrl && <a href={appStoreUrl} target="_blank" className={s.displayInlineBlock}>
                              <img alt="Image" src={AppStoreImage} />
                            </a>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div className={s.copyrightSection}>
                  <div>
                    <span className={s.footerSiteName}><FormattedMessage {...messages.copyRightLabel} /> © <b>{siteName} {moment().year()}.</b> <FormattedMessage {...messages.copyRightLabelDesc} /></span>
                  </div>
                  <div className={s.socialIcons}>
                    {
                      facebook && <a href={facebook} target="_blank" className={cs.cursorPointer}>
                        <img alt="" src={facebookIcon} />
                      </a>
                    }
                    {
                      twitter && <a href={twitter} target="_blank" className={cs.cursorPointer}>
                        <img alt="" src={twitterIcon} />
                      </a>
                    }
                    {
                      instagram && <a href={instagram} target="_blank" className={cs.cursorPointer}>
                        <img alt="" src={instagramIcon} />
                      </a>
                    }
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </footer>
    );
  }
}


const mapState = state => ({
  siteName: state.siteSettings.data.siteName,
  facebook: state.siteSettings.data.facebookLink,
  twitter: state.siteSettings.data.twitterLink,
  instagram: state.siteSettings.data.instagramLink,
  appAvailableStatus: state.siteSettings.data.appAvailableStatus,
  playStoreUrl: state.siteSettings.data.playStoreUrl,
  appStoreUrl: state.siteSettings.data.appStoreUrl
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState, mapDispatch),
  withQuery(getEnabledBlog,
    {
      options: {
        fetchPolicy: 'network-only',
        ssr: false
      }
    }),
  withQuery(getAllStaticPage,
    {
      options: {
        ssr: false,
        fetchPolicy: 'network-only'
      }
    }),
)(Footer);
